function getChartAttributes() {
  return {
    baseStyle:
      'height: 34px; line-height: 34px; padding: 5px; display: flex; align-items: center',

    popoutStyle:
      'height: 34px; line-height: 34px; padding: 5px; display: flex; align-items: center',
  };
}

export default getChartAttributes;
